import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

import {
Chart as ChartJS,
CategoryScale,
LinearScale,
PointElement,
LineElement,
Title,
Tooltip,
Legend
} from "chart.js";

import { Line } from "react-chartjs-2";

ChartJS.register(
CategoryScale,
LinearScale,
PointElement,
LineElement,
Title,
Tooltip,
Legend
);

function ViewsChart(){

const [views,setViews] = useState(0);

useEffect(()=>{

const fetchViews = async ()=>{

const ref = doc(db,"analytics","portfolioViews");
const snap = await getDoc(ref);

if(snap.exists()){
setViews(snap.data().count);
}

};

fetchViews();

},[]);

const labels = [
"Mon",
"Tue",
"Wed",
"Thu",
"Fri",
"Sat",
"Sun"
];

const data = {
labels,
datasets:[
{
label:"Portfolio Views",
data:[
views*0.2,
views*0.4,
views*0.3,
views*0.6,
views*0.5,
views*0.7,
views
],
borderColor:"#22c55e",
backgroundColor:"rgba(34,197,94,0.3)",
tension:0.4
}
]
};

const options = {
responsive:true,
plugins:{
legend:{
position:"top"
},
title:{
display:true,
text:"Portfolio Views (Last 7 Days)"
}
}
};

return(

<div style={{width:"100%",maxWidth:"600px",margin:"auto"}}>
<Line data={data} options={options} />
</div>

);

}

export default ViewsChart;